import React, { Component } from "react";
import PropTypes from "prop-types";
import { localStorageRemoveItem, localStorageGetItem, localStorageSetItem } from '../../persistence/localStorage';
import AudioSwitch from "./AudioSwitch";
import VideoPlayerFactory from "../../adapters/helpers/VideoPlayerFactory";
import { VideoPlayerConstants } from "../../adapters/helpers/Constants";
import { Cloudinary } from "cloudinary-core";
class VideoPlayerAudioDescription extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.videoPlayer = null;
    this.video = props.video;
    this.state = {
      video: null
    };
  }
  componentDidMount() {
    require('cloudinary-video-player');
    if (this.videoIsDefined()) {
      const videoPlayerFactory = new VideoPlayerFactory(this.videoRef, this.video);
      this.createVideoPlayer(videoPlayerFactory);
    }
    const cld = new Cloudinary({
      cloud_name: "OralB"
    });
    const videoPlayer = cld.videoPlayer("player", {
      muted: false,
      controls: true
    });
    let videoFile = videoPlayer.videojs;
    let ratioVolume = VideoPlayerConstants.videoRatioVolume;
    let firstAudiofile = document.getElementById('firstAudiofile');
    let secondAudiofile = document.getElementById('secondaudio');
    let audioDescriptionIcon = document.getElementsByClassName('vjs-icon-audio-description');
    localStorageRemoveItem("firstAudio");
    localStorageRemoveItem("secondAudio");
    if (firstAudiofile) {
      var _videoPlayer$videojs, _videoPlayer$videojs$;
      let ADButton = videoPlayer == null ? void 0 : (_videoPlayer$videojs = videoPlayer.videojs) == null ? void 0 : (_videoPlayer$videojs$ = _videoPlayer$videojs.controlBar) == null ? void 0 : _videoPlayer$videojs$.addChild('button');
      ADButton.el_.classList.add('vjs-icon-audio-description');
      if (audioDescriptionIcon && audioDescriptionIcon.length > 0) {
        audioDescriptionIcon[0].style.opacity = VideoPlayerConstants.descriptionButtonLowOpacity;
      }
      firstAudiofile.volume = ratioVolume;
      ADButton.on('click', function (e) {
        if (audioDescriptionIcon && audioDescriptionIcon.length > 0) {
          audioDescriptionIcon[0].style.opacity = VideoPlayerConstants.descriptionButtonHighOpacity;
        }
        if (firstAudiofile.volume) {
          firstAudiofile.pause();
          firstAudiofile.volume = 0;
          secondAudiofile.play();
        } else {
          firstAudiofile.volume = Math.min(videoFile.volume() + ratioVolume, 1);
          firstAudiofile.play();
          secondAudiofile.pause();
          if (audioDescriptionIcon && audioDescriptionIcon.length > 0) {
            audioDescriptionIcon[0].style.opacity = VideoPlayerConstants.descriptionButtonLowOpacity;
          }
        }
      });
      videoFile.on('play', function () {
        localStorageGetItem("firstAudio") == "pause" ? firstAudiofile.play() : localStorageGetItem("secondAudio") == "pause" ? secondAudiofile.play() : firstAudiofile.play();
      });
      videoFile.on('pause', function () {
        if (!firstAudiofile.paused) {
          firstAudiofile.pause();
          localStorageSetItem("firstAudio", "pause");
          localStorageRemoveItem("secondAudio");
        } else if (!secondAudiofile.paused) {
          secondAudiofile.pause();
          localStorageRemoveItem("firstAudio");
          localStorageSetItem("secondAudio", "pause");
        } else {
          firstAudiofile.pause();
          secondAudiofile.pause();
        }
      });
      videoFile.on('ended', function () {
        videoFile.pause();
        firstAudiofile.pause();
      });
      videoFile.on('volumechange', function () {
        firstAudiofile.volume = videoFile.volume();
        secondAudiofile.volume = videoFile.volume();
        if (videoFile.muted()) {
          firstAudiofile.muted = true;
          secondAudiofile.muted = true;
        } else {
          firstAudiofile.muted = false;
          secondAudiofile.muted = false;
        }
      });
      videoFile.on('timeupdate', function () {
        if (!firstAudiofile.paused && firstAudiofile.readyState >= 4) {
          if (Math.ceil(firstAudiofile.currentTime) != Math.ceil(this.currentTime())) {
            firstAudiofile.currentTime = this.currentTime();
          }
        }
        if (!secondAudiofile.paused && secondAudiofile.readyState >= 4) {
          if (Math.ceil(secondAudiofile.currentTime) != Math.ceil(this.currentTime())) {
            secondAudiofile.currentTime = this.currentTime();
          }
        }
      });
    }
  }
  createVideoPlayer(videoPlayerFactory) {
    var _this$props$video, _this$props$video$sub, _this$props$video2, _this$props$video2$ca, _this$props$video2$ca2, _this$props$video3, _this$props$video3$ca, _this$props$video3$ca2, _this$props$video4, _this$props$video4$ca, _this$props$video4$ca2, _this$props$video5, _this$props$video5$ca, _this$props$video5$ca2, _this$props$video6;
    const subTitles = (_this$props$video = this.props.video) == null ? void 0 : (_this$props$video$sub = _this$props$video.subTitles) == null ? void 0 : _this$props$video$sub.map(subtitle => {
      var _subtitle$fields, _subtitle$fields2, _subtitle$fields3;
      return {
        label: subtitle == null ? void 0 : (_subtitle$fields = subtitle.fields) == null ? void 0 : _subtitle$fields.label,
        language: subtitle == null ? void 0 : (_subtitle$fields2 = subtitle.fields) == null ? void 0 : _subtitle$fields2.language,
        url: subtitle == null ? void 0 : (_subtitle$fields3 = subtitle.fields) == null ? void 0 : _subtitle$fields3.url
      };
    });
    let textTracks = {
      captions: {
        label: (_this$props$video2 = this.props.video) == null ? void 0 : (_this$props$video2$ca = _this$props$video2.captions) == null ? void 0 : (_this$props$video2$ca2 = _this$props$video2$ca.fields) == null ? void 0 : _this$props$video2$ca2.label,
        default: (_this$props$video3 = this.props.video) == null ? void 0 : (_this$props$video3$ca = _this$props$video3.captions) == null ? void 0 : (_this$props$video3$ca2 = _this$props$video3$ca.fields) == null ? void 0 : _this$props$video3$ca2.default,
        language: (_this$props$video4 = this.props.video) == null ? void 0 : (_this$props$video4$ca = _this$props$video4.captions) == null ? void 0 : (_this$props$video4$ca2 = _this$props$video4$ca.fields) == null ? void 0 : _this$props$video4$ca2.language,
        url: (_this$props$video5 = this.props.video) == null ? void 0 : (_this$props$video5$ca = _this$props$video5.captions) == null ? void 0 : (_this$props$video5$ca2 = _this$props$video5$ca.fields) == null ? void 0 : _this$props$video5$ca2.url
      },
      subtitles: subTitles && [...subTitles]
    };
    textTracks = subTitles && ((_this$props$video6 = this.props.video) == null ? void 0 : _this$props$video6.captions) && textTracks;
    const source = textTracks ? {
      sourceTypes: ["webm", "mp4", "hls", "ogg"],
      textTracks: textTracks
    } : {
      sourceTypes: ["webm", "mp4", "hls", "ogg"]
    };
    videoPlayerFactory.create().then(({
      videoPlayer,
      transformation
    }) => {
      var _this$video, _this$video$asset, _this$video$asset$fie, _this$video$asset$fie2;
      const video = videoPlayer.Cloudinary.new({
        secure: true
      }).videoPlayer(this.videoRef.current, {
        loop: this.video.loop,
        fontFace: "inherit",
        fluid: true,
        preload: this.video.preload ? true : false,
        controls: this.video.controls,
        autoplayMode: this.video.autoplay,
        playsinline: this.video.playsInline
      }).transformation(transformation).source((_this$video = this.video) == null ? void 0 : (_this$video$asset = _this$video.asset) == null ? void 0 : (_this$video$asset$fie = _this$video$asset.fields) == null ? void 0 : (_this$video$asset$fie2 = _this$video$asset$fie.file) == null ? void 0 : _this$video$asset$fie2.url, source);
      this.setState({
        video: video
      });
      this.videoPlayer = video;
      this.videoPlayer.on("canplay", this.onVideoLoaded.bind(this));
      this.videoPlayer.on("play", this.onVideoPlay.bind(this));
      this.videoPlayer.on("pause", this.onVideoPause.bind(this));
      this.videoPlayer.on("mute", this.onVideoMuted.bind(this));
      this.videoPlayer.on("unmute", this.onVideoUnMuted.bind(this));
      this.videoPlayer.on("fullscreenchange", this.onVideoFullScreen.bind(this));
    }).catch(error => {
      console.error(error);
    });
  }
  videoIsDefined() {
    var _this$video2, _this$video2$asset, _this$video2$asset$fi, _this$video2$asset$fi2;
    return this.video && ((_this$video2 = this.video) == null ? void 0 : (_this$video2$asset = _this$video2.asset) == null ? void 0 : (_this$video2$asset$fi = _this$video2$asset.fields) == null ? void 0 : (_this$video2$asset$fi2 = _this$video2$asset$fi.file) == null ? void 0 : _this$video2$asset$fi2.url);
  }
  renderTranscript() {
    var _this$video3;
    return <div className="video-player-transcript visuallyhidden">
        {(_this$video3 = this.video) == null ? void 0 : _this$video3.transcript}
      </div>;
  }
  render() {
    var _this$props$video7, _this$props$video7$ca, _this$props$video8, _subtitlesVideo$, _this$props$video9, _this$props$video9$ke, _this$props$video9$ke2, _this$props$video9$ke3, _this$props$video9$ke4, _this$props$video10, _this$props$video10$k, _this$props$video10$k2, _this$props$video10$k3, _this$props$video10$k4, _this$props$video11, _this$props$video11$k, _this$props$video11$k2, _this$props$video11$k3, _this$props$video11$k4, _this$props$video11$k5, _this$props$video12, _this$props$video13, _this$props$video14, _this$props$video14$v, _this$props$video14$v2, _this$props$video15, _this$props$video15$v, _this$props$video15$v2, _this$props$video16, _this$props$video16$a, _this$props$video16$a2, _this$props$video16$a3, _this$props$video17, _this$video4, _this$video4$asset, _this$video4$asset$fi, _this$video4$asset$fi2, _this$video5, _this$video5$videoAud, _this$video5$videoAud2, _this$video5$videoAud3, _this$video6, _this$video6$videoAud, _this$video6$videoAud2, _this$video6$videoAud3;
    const captionsTrack = (_this$props$video7 = this.props.video) == null ? void 0 : (_this$props$video7$ca = _this$props$video7.captions) == null ? void 0 : _this$props$video7$ca.fields;
    const subtitlesVideo = (_this$props$video8 = this.props.video) == null ? void 0 : _this$props$video8.subTitles;
    const subTitleTrack = (subtitlesVideo == null ? void 0 : (_subtitlesVideo$ = subtitlesVideo[0]) == null ? void 0 : _subtitlesVideo$.fields) || null;
    const name = (_this$props$video9 = this.props.video) == null ? void 0 : (_this$props$video9$ke = _this$props$video9.keyframe) == null ? void 0 : (_this$props$video9$ke2 = _this$props$video9$ke.fields) == null ? void 0 : (_this$props$video9$ke3 = _this$props$video9$ke2.asset) == null ? void 0 : (_this$props$video9$ke4 = _this$props$video9$ke3.fields) == null ? void 0 : _this$props$video9$ke4.title;
    const description = (_this$props$video10 = this.props.video) == null ? void 0 : (_this$props$video10$k = _this$props$video10.keyframe) == null ? void 0 : (_this$props$video10$k2 = _this$props$video10$k.fields) == null ? void 0 : (_this$props$video10$k3 = _this$props$video10$k2.asset) == null ? void 0 : (_this$props$video10$k4 = _this$props$video10$k3.fields) == null ? void 0 : _this$props$video10$k4.description;
    const thumbnailurl = (_this$props$video11 = this.props.video) == null ? void 0 : (_this$props$video11$k = _this$props$video11.keyframe) == null ? void 0 : (_this$props$video11$k2 = _this$props$video11$k.fields) == null ? void 0 : (_this$props$video11$k3 = _this$props$video11$k2.asset) == null ? void 0 : (_this$props$video11$k4 = _this$props$video11$k3.fields) == null ? void 0 : (_this$props$video11$k5 = _this$props$video11$k4.file) == null ? void 0 : _this$props$video11$k5.url;
    const UploadDate = (_this$props$video12 = this.props.video) == null ? void 0 : _this$props$video12.uploadDate;
    const duration = (_this$props$video13 = this.props.video) == null ? void 0 : _this$props$video13.duration;
    const width = (_this$props$video14 = this.props.video) == null ? void 0 : (_this$props$video14$v = _this$props$video14.videoSettings) == null ? void 0 : (_this$props$video14$v2 = _this$props$video14$v.fields) == null ? void 0 : _this$props$video14$v2.width;
    const height = (_this$props$video15 = this.props.video) == null ? void 0 : (_this$props$video15$v = _this$props$video15.videoSettings) == null ? void 0 : (_this$props$video15$v2 = _this$props$video15$v.fields) == null ? void 0 : _this$props$video15$v2.height;
    const contenturl = (_this$props$video16 = this.props.video) == null ? void 0 : (_this$props$video16$a = _this$props$video16.asset) == null ? void 0 : (_this$props$video16$a2 = _this$props$video16$a.fields) == null ? void 0 : (_this$props$video16$a3 = _this$props$video16$a2.file) == null ? void 0 : _this$props$video16$a3.url;
    const ariaLabel = (_this$props$video17 = this.props.video) == null ? void 0 : _this$props$video17.ariaLabel;
    return <div className="ob-video-player videoAudioDescription">
        <video muted playsInline ref={this.videoRef} id="player" aria-label={ariaLabel} crossOrigin="anonymous">          
          <source src={'https:' + ((_this$video4 = this.video) == null ? void 0 : (_this$video4$asset = _this$video4.asset) == null ? void 0 : (_this$video4$asset$fi = _this$video4$asset.fields) == null ? void 0 : (_this$video4$asset$fi2 = _this$video4$asset$fi.file) == null ? void 0 : _this$video4$asset$fi2.url)} type="video/mp4" />
		      {captionsTrack && <track label={captionsTrack == null ? void 0 : captionsTrack.label} kind="captions" srcLang={captionsTrack == null ? void 0 : captionsTrack.language} src={captionsTrack == null ? void 0 : captionsTrack.url} default={captionsTrack == null ? void 0 : captionsTrack.default}></track>}
          {subTitleTrack && <track label={subTitleTrack == null ? void 0 : subTitleTrack.label} kind="subtitles" srcLang={subTitleTrack == null ? void 0 : subTitleTrack.language} src={subTitleTrack == null ? void 0 : subTitleTrack.url} default={subTitleTrack == null ? void 0 : subTitleTrack.default}></track>}
        </video>

        <AudioSwitch idValue="firstAudiofile" audioSrc={(_this$video5 = this.video) == null ? void 0 : (_this$video5$videoAud = _this$video5.videoAudio) == null ? void 0 : (_this$video5$videoAud2 = _this$video5$videoAud.fields) == null ? void 0 : (_this$video5$videoAud3 = _this$video5$videoAud2.file) == null ? void 0 : _this$video5$videoAud3.url} />

        <AudioSwitch idValue="secondaudio" audioSrc={(_this$video6 = this.video) == null ? void 0 : (_this$video6$videoAud = _this$video6.videoAudioDescription) == null ? void 0 : (_this$video6$videoAud2 = _this$video6$videoAud.fields) == null ? void 0 : (_this$video6$videoAud3 = _this$video6$videoAud2.file) == null ? void 0 : _this$video6$videoAud3.url} />
       
        {this.renderTranscript()}
      </div>;
  }
}
VideoPlayerAudioDescription.propTypes = {
  video: PropTypes.object,
  onVideoPlaying: PropTypes.func
};
export default VideoPlayerAudioDescription;